<h2 mat-dialog-title class="dialog-header">
  <span class="title">
    {{ "view_value.create_meter" | translate }}
  </span>

  <button mat-icon-button class="icon-close-btn" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="dialog-content">
  <form [formGroup]="formMeter" class="form-container">
    <div class="section">
      <div class="grid">
        <!-- Meter Info -->
        <div class="field">
          <label>{{ "view_value.meter_name" | translate }}</label>
          <mat-form-field
            appearance="outline"
            [class.edited]="isEdited('name')"
          >
            <input matInput formControlName="name" />
            <button
              mat-icon-button
              matSuffix
              *ngIf="isEdited('name')"
              (click)="undoField('name')"
            >
              <mat-icon>undo</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="field">
          <label>{{ "view_value.meter_id" | translate }}</label>
          <mat-form-field
            appearance="outline"
            [class.edited]="isEdited('meter_id')"
          >
            <input matInput formControlName="meter_id" />
            <button
              mat-icon-button
              matSuffix
              *ngIf="isEdited('meter_id')"
              (click)="undoField('meter_id')"
            >
              <mat-icon>undo</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="field">
          <label>{{ "view_value.sub_meter_id" | translate }}</label>
          <mat-form-field
            appearance="outline"
            [class.edited]="isEdited('sub_meter_id')"
          >
            <input matInput formControlName="sub_meter_id" />
            <button
              mat-icon-button
              matSuffix
              *ngIf="isEdited('sub_meter_id')"
              (click)="undoField('sub_meter_id')"
            >
              <mat-icon>undo</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <!-- Shop & Loop -->
        <div class="field">
          <label>{{ "view_value.tenant_name" | translate }}</label>
          <mat-form-field appearance="outline">
            <!-- <mat-label>{{ "view_value.tenant_name" | translate }}</mat-label> -->
            <input
              matInput
              formControlName="tenant_name"
              [matAutocomplete]="tenantAuto"
            />
            <mat-autocomplete #tenantAuto="matAutocomplete">
              @for (option of filteredOptionsTenant | async; track option) {
                <mat-option [value]="option.name">
                  {{ option.name }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <div class="field">
          <label>{{ "view_value.loop" | translate }}</label>
          <mat-form-field
            appearance="outline"
            [class.edited]="isEdited('loop_name')"
          >
            <mat-select formControlName="loop_name">
              <mat-option *ngFor="let loop of loops_list" [value]="loop?.id">
                {{ loop.name }}
                <button
                  mat-icon-button
                  matSuffix
                  *ngIf="isEdited('loop_name')"
                  (click)="undoField('loop_name')"
                >
                  <mat-icon>undo</mat-icon>
                </button>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Connection Info -->
        <!-- <div class="field">
          <label>{{ "view_value.conv_ip" | translate }}</label>
          <mat-form-field
            appearance="outline"
            [class.edited]="isEdited('conv_ip')"
          >
            <input matInput formControlName="conv_ip" />
            <button
              mat-icon-button
              matSuffix
              *ngIf="isEdited('conv_ip')"
              (click)="undoField('conv_ip')"
            >
              <mat-icon>undo</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="field">
          <label>{{ "view_value.port" | translate }}</label>
          <mat-form-field
            appearance="outline"
            [class.edited]="isEdited('port')"
          >
            <input matInput formControlName="port" />
            <button
              mat-icon-button
              matSuffix
              *ngIf="isEdited('port')"
              (click)="undoField('port')"
            >
              <mat-icon>undo</mat-icon>
            </button>
          </mat-form-field>
        </div> -->

        <!-- Panel / Brand / Model -->
        <div class="field">
          <label>{{ "view_value.panel_tier_5" | translate }}</label>
          <mat-form-field
            appearance="outline"
            [class.edited]="isEdited('panel')"
          >
            <mat-select formControlName="panel">
              <mat-option *ngFor="let panel of panels_list" [value]="panel.id">
                {{ panel.panel_tier_5 }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="field">
          <label>{{ "view_value.brand_name" | translate }}</label>
          <mat-form-field
            appearance="outline"
            [class.edited]="isEdited('brand')"
          >
            <mat-select formControlName="brand">
              <!-- <mat-option>
                    <ngx-mat-select-search
                      [formControl]="brandSearchCtrl"
                    ></ngx-mat-select-search>
                  </mat-option> -->
              <mat-option *ngFor="let items of get_brand" [value]="items">
                {{ items }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="field">
          <label>{{ "view_value.model" | translate }}</label>
          <mat-form-field
            appearance="outline"
            [class.edited]="isEdited('model')"
          >
            <mat-select formControlName="model">
              <mat-option *ngFor="let items of get_model" [value]="items.id">
                {{ items.model }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Serial Number -->
        <div class="field">
          <label>{{ "view_value.serial_number" | translate }}</label>
          <mat-form-field
            appearance="outline"
            [class.edited]="isEdited('serial_number')"
          >
            <input matInput formControlName="serial_number" />
          </mat-form-field>
        </div>

        <!-- Tags -->
        <div class="field full">
          <label>{{ "view_value.tag" | translate }}</label>
          <mat-form-field appearance="outline" class="full">
            <mat-chip-grid #chipGrid>
              <mat-chip-row
                *ngFor="let tag of formMeter.value.tags"
                (removed)="removeTag(tag)"
              >
                {{ getTagName(tag) }}
                <button matChipRemove>x</button>
              </mat-chip-row>

              <input
                placeholder="Add tag"
                #tagInput
                [formControl]="tagCtrl"
                [matAutocomplete]="auto"
                [matChipInputFor]="chipGrid"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="addTagFromAutocomplete($event)"
              />
            </mat-chip-grid>

            <mat-autocomplete
              #auto="matAutocomplete"
              (optionSelected)="selectedTag($event)"
            >
              <mat-option
                *ngFor="let tag of filteredTags | async"
                [value]="tag.name"
              >
                {{ tag.name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <!-- Description -->
        <div class="field full">
          <label>{{ "view_value.description" | translate }}</label>
          <mat-form-field
            appearance="outline"
            class="full"
            [class.edited]="isEdited('description')"
          >
            <textarea matInput formControlName="description"></textarea>
          </mat-form-field>
        </div>
      </div>
    </div>

    <!-- LOCATION SECTION -->
    <div class="section">
      <div class="section-title">
        {{ "view_value.location" | translate }}
      </div>
      <div class="grid">
        <div class="field">
          <label>{{ "view_value.location_tier_1" | translate }}</label>
          <mat-form-field appearance="outline">
            <mat-select formControlName="location_tier_1">
              <mat-option
                *ngFor="let item of locationList.location_tier_1"
                [value]="item"
                >{{ item }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>

        <div class="field">
          <label>{{ "view_value.location_tier_2" | translate }}</label>
          <mat-form-field appearance="outline">
            <mat-select formControlName="location_tier_2">
              <mat-option
                *ngFor="let item of locationList.location_tier_2"
                [value]="item"
                >{{ item }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>

        <div class="field">
          <label>{{ "view_value.location_tier_3" | translate }}</label>
          <mat-form-field appearance="outline">
            <mat-select formControlName="location_tier_3">
              <mat-option
                *ngFor="let item of locationList.location_tier_3"
                [value]="item"
                >{{ item }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>

        <div class="field">
          <label>{{ "view_value.location_tier_4" | translate }}</label>
          <mat-form-field appearance="outline">
            <mat-select formControlName="location_tier_4">
              <mat-option
                *ngFor="let item of locationList.location_tier_4"
                [value]="item"
                >{{ item }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
        <div class="field">
          <label>{{ "view_value.location_tier_5" | translate }}</label>
          <mat-form-field appearance="outline">
            <mat-select formControlName="location_tier_5">
              <mat-option
                *ngFor="let item of locationList.location_tier_5"
                [value]="item"
                >{{ item }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-button (click)="cancel()">
    {{ "view_value.cancel" | translate }}
  </button>
  <button mat-button (click)="resetAll()" [disabled]="getDiff().length === 0">
    {{ "view_value.reset" | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    [disabled]="formMeter.invalid"
    (click)="createMeter()"
  >
    {{ "view_value.create_meter" | translate }}
  </button>
</mat-dialog-actions>
